export default __webpack_public_path__ + "static/media/powered_by_realme.b3258e27.png";